export default __webpack_public_path__ + "static/media/ExcitingEnergy_02.626504f9.png";